<template>
  <div style="height:100%;width:100%;overflow-x:hidden">
    <div style="width:100%;height:80px;">
      <div  class="top" style="width:100%;height:80px;background:#262a36;">
        <el-button icon="el-icon-s-fold" style="height: 78px;width: 78px;" @click="toggle()"></el-button>
        <a class="logo"><img src="@/assets/images/logo.png"  @click="goTo('')" /></a>
        <ul class="top_ul">
          <li class="nav_more">
            <a href="#" style="width:90px;" class="shezhi"><img src="@/assets/images/bg25.png" /></a>
            <ul class="list_ol">
              <li><a href="#">设置</a></li>
              <li><a href="#" @click="logOut">退出登录</a></li>
            </ul>
          </li>
        </ul>
        <a href="#" @click="goTo('personalcenter')" class="admin"><img src="@/assets/images/bg24.png" /><span>{{UserTitle}}，{{$t('homepage.welcome')}}</span></a>
      </div>
    </div>

    <div class="hello" style="height:calc(100% - 80px);width: 100%;overflow:hidden!important;">
      <div style="height:100%;position:fixed;top:0,bottom:0,left:0;width:200px">
        <el-menu
          style="height:100%;text-align:left;width:100%;"
          default-active="homepage"
          class="el-menu-vertical-demo"
          background-color="#35414f"
          text-color="#b4bed0"
          active-text-color="#ffffff"
          @open="handleOpen"
          @close="handleClose"
          @select="handleSelect"
          :collapse="isCollapse"
          :collapse-transition="true"
          :unique-opened="true"
        >

          <el-menu-item index="homepage" id="homepage">
            <i class="el-icon-menu"></i>
            <span slot="title">首页</span>
          </el-menu-item>
          <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-s-platform"></i>
              <span>设备管理</span>
            </template>
            <el-menu-item index="equipmentmanagement" id="equipmentmanagement">设备列表</el-menu-item>
            <el-menu-item index="equipmentinspection" id="equipmentinspection">设备质检</el-menu-item>
            <el-menu-item index="malfunctionmanage" id="malfunctionmanage">故障列表</el-menu-item>
          </el-submenu>
          <el-submenu index="2">
            <template slot="title">
              <i class="el-icon-user"></i>
              <span>账号管理</span>
            </template>
            <el-menu-item index="logginaccount" id="logginaccount">登录账号</el-menu-item>
            <el-menu-item index="usermanagement" id="usermanagement">分配设备</el-menu-item>
            <el-menu-item index="payconfig" id="payconfig">收款配置</el-menu-item>
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">
              <i class="el-icon-coffee"></i>
              <span>饮品管理</span>
            </template>
            <el-menu-item index="beveragemanage" id="beveragemanage">配方库管理</el-menu-item>
            <el-menu-item index="beveragearrange" id="beveragearrange">配方库分配</el-menu-item>
            <el-menu-item index="speeddelay" id="speeddelay">速率延时</el-menu-item>
            <el-menu-item index="rawmaterial" id="rawmaterial">原料库管理</el-menu-item>
          </el-submenu>
          <el-submenu index="4">
            <template slot="title">
              <i class="el-icon-s-tools"></i>
              <span>标准数据配置</span>
            </template>
            <el-menu-item index="standardconfig" id="standardconfig">销售渠道配置</el-menu-item>
            <el-menu-item index="userlevelconfig" id="userlevelconfig">用户层级配置</el-menu-item>
          </el-submenu>
          <el-menu-item index="saledata" id="saledata">
            <i class="el-icon-s-data"></i>
            <span slot="title">销售数据统计</span>
          </el-menu-item>
          <el-menu-item index="remotecontrol" id="remotecontrol">
            <i class="el-icon-link"></i>
            <span slot="title">远程控制</span>
          </el-menu-item>
          <el-menu-item index="promotions" id="promotions">
            <i class="el-icon-s-ticket"></i>
            <span slot="title">优惠活动</span>
          </el-menu-item>
          <el-menu-item index="operatelog" id="operatelog">
            <i class="el-icon-s-order"></i>
            <span slot="title">{{$t('myduty.operationLog')}}</span>
          </el-menu-item>
          <el-menu-item index="trafficwarning" id="trafficwarning">
            <i class="el-icon-warning-outline"></i>
            <span slot="title">流量预警</span>
          </el-menu-item>
          <el-menu-item index="myduty" id="myduty">
            <i class="el-icon-s-claim"></i>
            <span slot="title">我的任务</span>
          </el-menu-item>
        </el-menu>
      </div>


    </div>

  </div>

</template>

<script>
  import homepage from '@/pages/homepage/homepage'
  import equipmentmanagement from '@/pages/equipmentmanagement/equipmentmanagement'
  export default {
    name: 'index',
    components: {
      homepage,
      equipmentmanagement
    },
    data () {
      return {
        link:'',
        isCollapse:false,
        UserTitle:"",
        contentStyle:{
          height:"100%",
          position:"relative",
          transition:'all .5s',
          'margin-left':"200px"
        },
        editableTabsValue: '2',
        editableTabs: [{
          title: 'Tab 1',
          name: '设备列表',
          content: 'Tab 1 content'
        }, {
          title: 'Tab 2',
          name: '2',
          content: 'Tab 2 content'
        }],
        tabIndex: 2
      }
    },
    mounted(){

      //查看用户是否登录
      if(!this.$account.data){
        let token = this.$cookies.get("token");
        if(!token){
          this.$router.push("/login");
        }else{
          //获取用户信息
          let that = this;
          let tokenStr = "Bearer "+token;
          this.$httpservice.get("api/account/currentaccount",{},{Authorization:tokenStr} ).then(
            function (data) {
              if(data.body.code=="200"){
                that.$account.data = data.body.data;
                that.UserTitle = data.body.data.accountName;
              }else{
                that.$message({
                  message: data.body.msg,
                  type: 'danger'
                });
                that.$router.push("/login");
              }
            },
            function (data) {
              let statusCode = data.status;
              that.$message({
                message: that.$t('queryFailedStatusCode')+statusCode,
                type: 'warning'
              });
              that.$router.push("/login");
            }
          );
        }
      }else{
        this.UserTitle = this.$account.data.accountName;
      }



    },
    methods:{
      handleClose(){

      },
      handleSelect(index,indexPath){
        this.$router.push("/home/"+index);
      },
      handleOpen(){

      },
      goTo(index){
        //直接跳转
        this.$router.push("/home/"+index);
      },
      toggle(){
        this.isCollapse = !this.isCollapse;
        if(this.isCollapse==true){
          this.contentStyle['margin-left'] = "74px";

        }else{
          this.contentStyle['margin-left'] = "200px";
        }
      },
      logOut(){
        this.$cookies.remove("token");
        this.$account.data = null;
        this.$router.push("/login");
      },
      addTab(targetName) {
        let newTabName = ++this.tabIndex + '';
        this.editableTabs.push({
          title: 'New Tab',
          name: newTabName,
          content: 'New Tab content'
        });
        this.editableTabsValue = newTabName;
      },
      removeTab(targetName) {
        let tabs = this.editableTabs;
        let activeName = this.editableTabsValue;
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1];
              if (nextTab) {
                activeName = nextTab.name;
              }
            }
          });
        }

        this.editableTabsValue = activeName;
        this.editableTabs = tabs.filter(tab => tab.name !== targetName);
      }

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;color:#b4bed0;
    /*margin: 0 10px;*/width: 100%;
  }
  a {
    color: #42b983;
  }
  .top{ width:100%;height:80px;margin:0 auto; }
  .top .logo{ display:inline-block;width:30%;margin:10px 0px 0px 10px;float:left;text-align:left; position:absolute;left:70px;}
  .top .logo img{width:70%;}

  .top .admin{ display:inline-block;float:right;line-height:80px;font-size:18px;color:#fff; overflow:hidden;}
  .top .admin span{ display:inline-block;float:left;line-height:80px;font-size:18px;color:#fff;}

  .top .admin img{width:40px;height:40px;margin:20px 10px 0px 0px; float:left;}
  .top .top_ul{ float:right;margin:0px 20px 0px 0px; z-index:100001;padding:0;}
  .top .top_ul li{list-style:none;display:inline;float:left;padding:0;}
  .top .top_ul li .shezhi{display:block;float:left;padding:20px 10px 7px 10px;text-align:center;line-height:40px !important;font-family:"微软雅黑";font-size:18px;color:#fff;}
  .top .top_ul li a:hover{}

  .top .top_ul li .nav_specile{background:#fb8e00;color:#fff;}
  .top .nav_more{}
  .top .nav_more a:hover{color:#fff;}
  .top .nav_more:hover .list_ol{display:block;}
  .top .nav_more .list_ol{position:absolute;top:80px;width:110px;background:#35414f;display:none;padding:0px;border-top:none; z-index:100000; }
  .top .nav_more .list_ol li a{display:block; text-align:center;width:110px;line-height:2.5;color:#b4bed0;font-size:15px;font-family:"微软雅黑";}
  .top .nav_more .list_ol li a:hover{background:#35414f;border-bottom:none;color:#fff;line-height:2.5;}


  .el-menu{width:16%;}

  .el-menu--collapse{width:74px !important;}


  .el-button:focus, .el-button:hover {
    color: #b4bed0;
    border-color:none !important;
  }

  .el-button {
    display: inline-block;
    line-height:1.8;
    white-space: nowrap;
    cursor: pointer;
    background:none;
    color: #fff;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    -webkit-transition: .1s;
    transition: .1s;
    font-weight: 500;
    padding: 13px 20px; position:absolute;left:0;
    font-size:30px;
    border-radius:0px!important;
    border:none !important;
    outline-style:none;
  }

  .el-submenu .el-menu-item {
    min-width: 100px;
    background-color: #465f74;
  }



</style>



// WEBPACK FOOTER //
// src/pages/index.vue